import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Icon from "../components/Icon";
import { AuditBlock } from "../components/SignOff";
import ReportActions from "../components/ReportActions";
import { apiGet } from "../api";
import { formatYmd, formatStamp } from "../dateutil";
import { C, R, S } from "../theme";

const outcomeLabel = (o) => (o === "needs_retraining" ? "Needs retraining" : o === "competent" ? "Competent" : "-");

export default function TrainingDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [t, setT] = useState(null);
  useEffect(() => { apiGet(`/training/${id}`).then(setT); }, [id]);
  if (!t) return <div style={{ color: C.amber, textAlign: "center", paddingTop: 80 }}>Loading…</div>;
  const row = (l, v) => <div style={{ display: "flex", justifyContent: "space-between", padding: `${S.sm}px 0`, borderBottom: `1px solid ${C.border}` }}><span style={{ color: C.muted }}>{l}</span><span style={{ color: C.text, fontWeight: 700, textAlign: "right", marginLeft: S.md }}>{v}</span></div>;
  const trainer = t.signed_by_name || t.trainer_name;
  const hasTrainee = !!(t.trainee_signature || t.trainee_name);
  return (
    <div className="fade-up">
      <div style={{ display: "flex", alignItems: "center", gap: S.sm, padding: S.lg }}>
        <button className="pressable" onClick={() => nav(-1)}><Icon name="chevron-back" size={28} color={C.text} /></button>
        <div className="display" style={{ color: C.text, fontSize: 20, fontWeight: 900 }}>Training Record</div>
      </div>
      <div style={{ padding: S.lg }}>
        <div style={{ background: C.card, borderRadius: R.md, padding: S.md, border: `1px solid ${C.border}` }}>
          {row("Staff (trainee)", t.staff_name)}{row("Trainer", t.trainer_name)}{row("Attraction", t.attraction_name)}{row("Date", formatYmd(t.date_trained))}
          {t.assessment_outcome && row("Outcome", outcomeLabel(t.assessment_outcome))}
          {t.renewal_date && row("Renewal due", formatYmd(t.renewal_date))}
          {t.location && row("Location", t.location)}
        </div>
        <div style={{ color: C.text, fontSize: 18, fontWeight: 800, marginTop: S.lg, marginBottom: S.sm }}>Topics Covered</div>
        {(t.topics || t.competencies || []).map((c) => <div key={c} style={{ display: "flex", alignItems: "center", gap: S.sm, background: C.card, borderRadius: R.md, padding: S.md, marginBottom: S.sm, border: `1px solid ${C.border}` }}><Icon name="checkmark-circle" size={18} color={C.green} /><span style={{ color: C.text }}>{c}</span></div>)}

        <div style={{ color: C.text, fontSize: 18, fontWeight: 800, marginTop: S.lg, marginBottom: S.sm }}>Trainer / Assessor Sign-Off</div>
        <AuditBlock signature={t.signature} name={trainer} initials={t.signed_by_initials} submittedAt={t.created_at} label="Trainer / Assessor Sign-Off & Audit Block" />
        {hasTrainee && (
          <>
            <div style={{ color: C.text, fontSize: 18, fontWeight: 800, marginTop: S.lg, marginBottom: S.sm }}>Trainee Sign-Off</div>
            <AuditBlock signature={t.trainee_signature} name={t.trainee_name} initials={t.trainee_initials} submittedAt={t.created_at} label="Trainee Sign-Off & Audit Block" />
          </>
        )}
        <div style={{ height: S.md }} />
        <ReportActions report={{
          title: `Training Record — ${t.staff_name}`,
          company: t.attraction_name,
          rows: [], columns: [], photos: [],
          meta: {
            details: [
              { label: "Staff (trainee)", value: t.staff_name }, { label: "Trainer", value: t.trainer_name },
              { label: "Attraction", value: t.attraction_name }, { label: "Date", value: formatYmd(t.date_trained) },
              { label: "Outcome", value: t.assessment_outcome ? outcomeLabel(t.assessment_outcome) : null },
              { label: "Renewal due", value: t.renewal_date ? formatYmd(t.renewal_date) : null },
              { label: "Topics Covered", value: (t.topics || t.competencies || []).join(", ") },
            ],
            signature: t.signature, signedBy: trainer, initials: t.signed_by_initials, submittedAt: formatStamp(t.created_at),
            signLabel: "Trainer / Assessor Sign-Off & Audit Block",
            trainee: hasTrainee ? { signature: t.trainee_signature, name: t.trainee_name, initials: t.trainee_initials } : null,
            docType: "TR", recordId: t.id, siteLocation: t.location, attractionName: t.attraction_name,
          },
        }} />
        <div style={{ height: S.xxl }} />
      </div>
    </div>
  );
}
